<h1 class="matp-page-title">掲示板メッセージ一覧</h1>

<!-- 掲示板メッセージ一覧 -->
<div [formGroup]="historyFormGroup" class="tw-mb-8 tw-w-[500px]">
  <div class="tw-flex tw-space-x-4 tw-items-center">
    <mat-form-field
      appearance="fill"
      class="tw-flex-1"
      (click)="startDatePicker.open()"
    >
      <mat-label>対象期間（開始）</mat-label>
      <input
        matInput
        [matDatepicker]="startDatePicker"
        placeholder="YYYY/MM/DD"
        formControlName="historyFrom"
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="startDatePicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #startDatePicker></mat-datepicker>
      <mat-error
        *ngIf="historyFormGroup.controls['historyFrom'].errors?.['required']"
      >
        対象期間（開始）を入力してください。
      </mat-error>
    </mat-form-field>
    <span class="tw-mx-2">~</span>
    <mat-form-field
      appearance="fill"
      class="tw-flex-1"
      (click)="endDatePicker.open()"
    >
      <mat-label>対象期間（終了）</mat-label>
      <input
        matInput
        [matDatepicker]="endDatePicker"
        placeholder="YYYY/MM/DD"
        formControlName="historyTo"
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="endDatePicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #endDatePicker></mat-datepicker>
    </mat-form-field>

    <button
      mat-raised-button
      id="search-btn"
      class="tw-text-lg tw-mx-2"
      color="primary"
      (click)="initNotificationDetailList()"
      [disabled]="historyFormGroup.invalid"
    >
      <mat-icon>search</mat-icon>
      <span>検索</span>
    </button>
  </div>
  <div class="tw-text-xs">
    @if (historyFormGroup.errors?.["dateRange"]) {
      <mat-error
        >検索終了日は検索開始日より後の日付を入力してください。</mat-error
      >
    }
  </div>
</div>

<mat-card class="matp-card">
  <app-notification-list-table
    [notificationList]="notificationList"
    [statusList]="statusList"
    (created)="openNotificationEditDialog()"
    (updated)="openNotificationEditDialog($event)"
    (deleted)="deleteNotification($event)"
  ></app-notification-list-table>
</mat-card>
